import * as d3 from 'd3';
import { addToStack, getPositionInScene } from "../Util";
import { createNewItem, select } from "../canvasSlice";
import store from "../store";

let clickHeld = false, moved = false, downX, downY;

export const mouseDown = (e, scene) => {
    clickHeld = true;
    const p = getPositionInScene(e.clientX, e.clientY);
    downX = p[0];
    downY = p[1];
}

export const mouseUp = (e, scene, datasets, renderer, undoStack) => {
    clickHeld = false;
    let c = d3.select("#circleToolUI");
    c.style("visibility", "hidden");
    if (moved) {
        addToStack(scene, datasets, undoStack);
        let r = scene.mark("circle", {x: parseInt(c.attr("cx")), y: parseInt(c.attr("cy")), 
                radius: parseInt(c.attr("r")), fillColor: "none"});
        store.dispatch(createNewItem(r.id));
        store.dispatch(select([r.id]));
        renderer.render(scene);
    }
    moved = false;
}

export const mouseMove = (e, scene) => {
    if (!clickHeld) return;
    moved = true;
    let p = getPositionInScene(e.clientX, e.clientY);
    let x1 = downX, x2 = p[0], y1 = downY, y2 = p[1];
    let cx = (x1 + x2)/2, cy = (y1 + y2)/2, r = Math.min(Math.abs(x1 - x2)/2, Math.abs(y1 - y2)/2);
    d3.select("#circleToolUI").style("visibility", "visible").attr("cx", cx).attr("cy", cy)
        .attr("r", r);
}